import { connect, ConnectedProps } from 'react-redux';
import { progressSelectorFactory } from '../../../../common/store/selectors';
import { RootState } from '../../../../reducers';
import { selectClientId, selectEntityDetails } from '../common/store/selectors';
import { CashAccounts } from './components/cashAccounts';
import {
  selectCanShowAudValues,
  selectCashAccountOptions,
  selectCashStatementResults,
  selectLastDataRefresh,
  selectParameters,
  selectSelectedAccountLabel,
  selectShowAudValues,
} from './store/selectors';
import { cashAccountsSlice } from './store/slice';
import { CashAccountsActionTypes, downloadCashStatements, fetchCashAccounts, fetchCashStatements } from './store/thunks';

const mapStateToProps = (state: RootState) => ({
  clientId: selectClientId(state),
  entityDetails: selectEntityDetails(state),
  cashStatements: selectCashStatementResults(state),
  lastDataRefresh: selectLastDataRefresh(state),
  cashAccounts: selectCashAccountOptions(state),
  selectedAccountLabel: selectSelectedAccountLabel(state),
  parameters: selectParameters(state),
  showAudValues: selectShowAudValues(state),
  canShowAudValues: selectCanShowAudValues(state),
  progressCashStatements: progressSelectorFactory([CashAccountsActionTypes.FetchCashStatements])(state),
  progressCashAccounts: progressSelectorFactory([CashAccountsActionTypes.FetchCashAccounts])(state),
});

const mapDispatchToProps = {
  ...cashAccountsSlice.actions,
  fetchCashAccounts,
  fetchCashStatements,
  downloadCashStatements,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export type Props = ConnectedProps<typeof connector>;
export const CashAccountsStateContainer = connect(mapStateToProps, mapDispatchToProps)(CashAccounts);
